export default "__VITE_ASSET__C6O2ITUQ__"